/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Rush Hour Real Estate Platform API
 * MVP платформы недвижимости - публичные эндпоинты
 * OpenAPI spec version: 1.0.0
 */

export type ListProjectsSort = (typeof ListProjectsSort)[keyof typeof ListProjectsSort]

export const ListProjectsSort = {
  price_asc: 'price_asc',
  price_desc: 'price_desc',
  newest: 'newest',
  name_asc: 'name_asc',
} as const
